import * as React from "react"
import LayoutBlogDiversity from "../components/LayoutBlogDiversity"
import BlogPage2 from "../components/BlogPage/BlogPage2"
import AccordianDropdown from "../components/BlogPage/AccordianDropdown"
import CommentBox from '../components/BlogPage/CommentBox'

function blog({ data }) {
  return (
    <LayoutBlogDiversity>
      <BlogPage2/>
      <AccordianDropdown/>
      {/* <CommentBox /> */}
    </LayoutBlogDiversity>
  )
}

export default blog




